/** 手机触控：独立操作按钮使用至少44px点击区域；桌面保持原紧凑布局，业务权限、提交与跳转逻辑不变。 */
import { ResponsiveTable } from "../mobile/ResponsiveTable";
/** 手机记录列表复用原有数据、勾选与业务操作；普通记录按字段卡片呈现，交互表头和对比矩阵保留横向浏览。 */
import { X, ExternalLink } from "lucide-react";
import { STAGE_LABEL } from "../../data/crm";

const k = (v) => `$${Math.round((v || 0) / 1000)}k`;

// 预测月份下钻：点柱 → 该月线索明细（客户 · 阶段 · 金额 · 概率 · 加权 · 推算 / 估算 · 销售）
export function ForecastMonthDrill({ forecast, month, zh, onClose, onOpenLead }) {
  if (!month || !forecast) return null;
  const rows = (forecast.leads || []).filter((l) => l.month === month);
  const m = (forecast.byMonth || []).find((x) => x.month === month) || {};
  const stage = (s) => (zh ? STAGE_LABEL[s]?.zh : STAGE_LABEL[s]?.en) || s;
  return (
    <div className="mt-2 rounded-lg border border-indigo-200 bg-white/80 p-2.5" data-testid="crm-forecast-drill" data-month={month} data-count={rows.length}>
      <div className="flex-wrap md:flex-nowrap flex items-center justify-between gap-2 mb-1.5">
        <p className="text-xs font-semibold text-indigo-700" data-testid="crm-forecast-drill-title">
          {month} · {zh ? `${rows.length} 条线索` : `${rows.length} leads`} · {zh ? "加权" : "Weighted"} {k(m.weighted)} / {zh ? "在途" : "Raw"} {k(m.raw)}
          {m.inferred > 0 && <span className="ml-1.5 text-[10px] font-normal text-amber-600" data-testid="crm-forecast-drill-inferred">· {zh ? `${m.inferred} 条月份为推算` : `${m.inferred} inferred`}</span>}
        </p>
        <button type="button" onClick={onClose} className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 text-slate-400 hover:text-slate-700 p-0.5" data-testid="crm-forecast-drill-close" title={zh ? "收起" : "Close"}><X className="h-3.5 w-3.5" /></button>
      </div>
      {rows.length === 0 ? <p className="text-[11px] text-slate-400 py-2 text-center" data-testid="crm-forecast-drill-empty">{zh ? "该月暂无线索明细" : "No leads"}</p> : (
        <div className="max-h-56 overflow-y-auto -mx-1 px-1">
          <ResponsiveTable className="w-full text-[11px]">
            <thead className="text-slate-400 text-left">
              <tr>
                <th className="py-1 font-medium">{zh ? "客户" : "Client"}</th>
                <th className="py-1 font-medium">{zh ? "阶段" : "Stage"}</th>
                <th className="py-1 font-medium text-right">{zh ? "金额" : "Amount"}</th>
                <th className="py-1 font-medium text-right">{zh ? "概率" : "Prob"}</th>
                <th className="py-1 font-medium text-right">{zh ? "加权" : "Weighted"}</th>
                <th className="py-1 font-medium hidden sm:table-cell">{zh ? "销售" : "Sales"}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((l) => (
                <tr key={l.id} className="border-t border-slate-100" data-testid={`crm-forecast-drill-row-${l.id}`} data-estimated={l.estimated ? 1 : 0} data-inferred={l.inferred ? 1 : 0}>
                  <td className="py-1 pr-1 min-w-0">
                    <button type="button" onClick={() => onOpenLead(l.id)} className="inline-flex items-center gap-1 text-indigo-700 hover:underline font-medium truncate max-w-[9rem]" data-testid={`crm-forecast-drill-open-${l.id}`}>
                      {l.clientName}<ExternalLink className="h-3 w-3 shrink-0 opacity-60" />
                    </button>
                    {l.inferred && <span className="ml-1 text-[9px] px-1 rounded bg-amber-50 text-amber-600 border border-amber-100">{zh ? "推算" : "inferred"}</span>}
                  </td>
                  <td className="py-1 pr-1 text-slate-600 whitespace-nowrap">{stage(l.stage)}</td>
                  <td className="py-1 pr-1 text-right whitespace-nowrap text-slate-700">{k(l.amount)}{l.estimated && <span className="ml-0.5 text-[9px] text-amber-600" title={zh ? "按历史签约中位数估算" : "estimated"}>{zh ? "估" : "est"}</span>}</td>
                  <td className="py-1 pr-1 text-right text-slate-500">{Math.round((l.prob || 0) * 100)}%</td>
                  <td className="py-1 pr-1 text-right font-semibold text-indigo-600 whitespace-nowrap">{k(l.weighted)}</td>
                  <td className="py-1 text-slate-500 hidden sm:table-cell truncate max-w-[6rem]">{l.assignedSales || "—"}</td>
                </tr>
              ))}
            </tbody>
          </ResponsiveTable>
        </div>
      )}
    </div>
  );
}
